import { Button, Input, message, Space } from 'antd'
import { useToken } from 'app/hooks'
import { set } from 'lodash'
import React from 'react'
import { View } from 'styles/reactnative'
import useSWR from 'swr'
import API from 'utils/api'

const PSlipage = ({ user_id, ep_id, group_id="*" }) => {
	const { data: token } = useToken()

	const [force, setForce] = React.useState<any>(null)
	const [max, setMax] = React.useState<any>(null)

	const [gforce, setGForce] = React.useState<any>(null)
	const [gmax, setGMax] = React.useState<any>(null)


	// const { data:gslip } = useSWR(`/admin/slip/gslip?group_id=${group_id}&ep_id=*`, async url => {
	// 	const res = await API.get(url, token + '', {}, false).then(
	// 		res => res?.result
	// 	)
	// 	return res || []
	// })


	const { data } = useSWR(`/admin/slip/pslip?user_id=${user_id}&ep_id=*`, async url => {
		const res = await API.get(url, token + '', {}, false).then(
			res => res?.result
		)
		return res || []
	})




	React.useEffect(() => {
		if (data?.result) {
			const find = data?.result?.find(i => i.ep_id == ep_id )?.value
			if (find) {
				const split = find.split(':')
				setForce(split[0])
				setMax(split[1])
			}

			const gfind = data?.gresult?.find(i => i.ep_id == ep_id )?.value
			if(gfind){
				const gsplit = gfind?.split(":");
				setGForce(gsplit[0])
				setGMax(gsplit[1])
			}
		}
	}, [data])

	return (
		<Space style={{ width: '100%', padding:0, gap:0, fontSize:11 }} size={'small'} direction="horizontal">
			강제
			<Input
				value={force || gforce || 0}
				onChange={e => setForce(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10, background: gforce > 0 ?'#cccccc':force> 0 ? '#f1eeee' : '#ffffff' }}
			/>{' '}
			최대
			<Input
				value={max || gmax || 1000}
				onChange={e => setMax(e.target.value)}
				type="number"
				max={1000}
				min={0}
				style={{ width: 60, fontSize: 10, background: gmax> 0?'#cccccc': max> 1000 ? '#f1eeee' : '#ffffff' }}
			/>
			<Button
				type="primary"
				onClick={() => {
					API.post(`/admin/slip/pslip`, token + '', {
						user_id,
						ep_id,
						force,
						max,
					}).then(res => {
						message.success('적용되었습니다.')
					})
				}}
				size="small">
				반영
			</Button>
			<Button
				onClick={() => {
					API.post(`/admin/slip/pslip`, token + '', {
						ep_id,
						force:0,
						max:0,
					}).then(res => {
						message.success('삭제되었습니다.')
					})
				}}
				size="small">
				삭제
			</Button>
		</Space>
	)
}

export default React.memo(PSlipage)
